import React from 'react';
import { twMerge } from 'tailwind-merge';

const PostSection = ({
  title,
  requiredTitle = false,
  withTopBorder = false,
  withBottomBorder = true,
  paddingClassName = 'py-4 tabletH:py-[50px]',
  className,
  children,
}) => {
  return (
    <section
      className={twMerge(
        `w-full flex flex-col gap-[30px] ${
          title === 'Perks and Benefits' ? 'tabletH:gap-4' : 'tabletH:gap-8'
        }`,
        withTopBorder && 'tabletH:border-t tabletH:border-grayscale-gray02',
        withBottomBorder && 'tabletH:border-b tabletH:border-grayscale-gray02',
        paddingClassName,
        className,
      )}
    >
      <div className='hidden items-start gap-0.5 tabletH:flex typo-b16Strong tabletH:typo-b18Strong'>
        <h2 className='text-text-primary'>{title}</h2>
        {requiredTitle && <span className='text-text-accent'>*</span>}
      </div>
      {children}
    </section>
  );
};

export default PostSection;
